export const IS_DEV = process.env.NODE_ENV !== 'production';

export const buildPaymentPayload = ({ companyId, subscriptionId, selectedPlanDetails }) => {
  // Prefer backend minor-unit amount (paise). Avoid totalWithGst * 100 — that
  // round-trips through float division in planUtils and can yield non-integers
  // (e.g. 235882.00000000003), which fail backend Number.isInteger checks.
  const amount =
    selectedPlanDetails?.price?.amountWithGst ??
    Math.round((selectedPlanDetails?.totalWithGst ?? 0) * 100);

  return {
    operation: "initiatePayment",
    payload: {
      subscriptionId,
      amount,
      currency: selectedPlanDetails?.price?.currency ?? "INR",
      exponent: selectedPlanDetails?.price?.exponent ?? 2,
      idempotencyKey: `${companyId}_${subscriptionId}_${Date.now()}_${crypto.randomUUID()}`,
    },
  };
};

export const buildWalletRechargePayload = ({ companyId, amountInPaise }) => ({
  operation: "initiatePayment",
  payload: {
    paymentPurpose: "WALLET_RECHARGE",
    amount: amountInPaise,
    currency: "INR",
    idempotencyKey: `${companyId}_wallet_${Date.now()}_${crypto.randomUUID()}`,
  },
});
